import React from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { CustomTable, Loading } from 'src/components'
import { AnimalCard } from 'src/components/AnimalCard'
import ROUTES from 'src/constants/routes'
import { useAnimalHeaderTable } from './hooks/useAnimalHeaderTable'
import { AnimalHeader } from './components/Header'
import { useAnimalViewMode } from './hooks/useAnimalViewMode'
import { IAnimal } from 'src/dto/animal.dto'
import { useAnimalList } from './hooks/useAnimalList'
import { useAnimalDetailsModal } from './hooks/useAnimalDetailsModal'

export const Animal: React.FC = () => {
  const navigate = useNavigate()

  const [searchParams, setSearchParams] = useSearchParams()
  const id = searchParams.get('id')

  const { tableHeader } = useAnimalHeaderTable()

  const {
    animalList,
    animalListData,
    isLoadingAnimalListing,
    isLoadingBreedListing,
    isFetchingNextPage,
    fetchNextPage,
    refetch,
    searchValue,
    handleSearchChange,
    isError
  } = useAnimalList()

  const { modal } = useAnimalDetailsModal({
    id: id!
  })

  const { tableViewMode, filterIsActiver, changeTableViewMode, handleFilterActiver } = useAnimalViewMode()

  const isInitialLoading = !searchValue && isLoadingAnimalListing && isLoadingBreedListing

  return (
    <>
      <AnimalHeader
        mode={tableViewMode}
        changeMode={changeTableViewMode}
        onToggleFilter={() => handleFilterActiver(!filterIsActiver)}
        onCreate={() => navigate(ROUTES.ANIMAL.NEW)}
        filterDisabled={isInitialLoading || !animalList?.length}
        toggleDisabled={isInitialLoading}
        createDisabled={isInitialLoading}
      />

      {isInitialLoading ? (
        <Loading />
      ) : (
        <>
          <CustomTable
            header={tableHeader}
            body={animalList || []}
            propertiesToFilter={['nome', 'cdn', 'sexo', 'raca', 'rgn']}
            viewMode={tableViewMode}
            filterIsActive={filterIsActiver}
            cardComponent={(cardData: IAnimal) => <AnimalCard cardData={cardData} />}
            onClickItem={(animal) => {
              searchParams.set('id', animal.id)
              setSearchParams(searchParams)
            }}
            fetchNextPage={fetchNextPage as any}
            isFetchingNextPage={isLoadingAnimalListing || isFetchingNextPage}
            isError={isError}
            refetch={refetch}
            totalPages={animalListData?.pages?.[0]?.totalPages || 0}
            totalItens={animalListData?.pages?.[0]?.total || 0}
            isRemoteSearch
            onSearchChange={handleSearchChange}
            searchValue={searchValue}
          />

          {modal}
        </>
      )}
    </>
  )
}
